import React from "react";

const Main = ({ className: styledClassName = "", children = null }) => {
    return <div className={`${styledClassName} page-main`}>{children}</div>;
};

export default Main;
